import React, { Component, Fragment } from 'react';
import { FieldTypes, passwordField, timeSlotPicker } from 'drapcode-constant';
import TextField from './ItemField/TextField';
import TextArea from './ItemField/TextArea';
import TextAreaWithoutTextEditor from './ItemField/TextAreaWithoutTextEditor';
import Reference from './ItemField/Reference';
import BooleanField from './ItemField/BooleanField';
import NumberField from './ItemField/NumberField';
import DateTimeField from './ItemField/DateTimeField';
import FileUploadField from './ItemField/FileUploadField';
import ImageUploadField from './ItemField/ImageUploadField';
import MultiImageUploadField from './ItemField/MultiImageUploadField';
import StaticOptions from './ItemField/StaticOptions';
import DynamicOptions from './ItemField/DynamicOptions';
import ReferenceFieldForm from './ItemField/ReferenceFieldForm';
import PhoneNumberField from './ItemField/PhoneNumberField';
import EmailField from './ItemField/EmailField';
import { ColorCodeField } from './ItemField/ColorCodeField';
import SlugField from './ItemField/SlugField';
import JSONField from './ItemField/JSONField';
import MarkdownField from './ItemField/MarkdownField';
//TODO: Refactor
const {
  text,
  url,
  email,
  tel,
  large_text,
  reference,
  belongsTo,
  dynamic_option,
  boolean,
  number,
  unix_timestamp,
  date,
  file,
  image,
  multi_image,
  static_option,
  color,
  slug,
  json,
  markdown,
} = FieldTypes;

class CreateFormForItem extends Component {
  render() {
    const {
      field,
      isConstructorForm,
      setFieldValue,
      values,
      projectId,
      collections,
      version,
      setSubmitting,
      collectionId,
      setErrors,
      plugins,
      s3Url,
    } = this.props;
    const { projectDetail } = collections;
    return (
      <Fragment>
        {[...passwordField, url.id].includes(field.type) && (
          <TextField
            field={field}
            isConstructorForm={isConstructorForm}
            values={values}
            collections={collections.projectCollections}
          />
        )}
        {field.type === large_text.id &&
        field.extraFieldSetting &&
        field.extraFieldSetting.textareaDisplayType === 'text-editor' ? (
          <TextArea
            setFieldValue={setFieldValue}
            field={field}
            isConstructorForm={isConstructorForm}
            values={values}
            projectId={projectId}
            version={version}
            s3Url={s3Url}
          />
        ) : (
          field.type === large_text.id && (
            <TextAreaWithoutTextEditor
              setFieldValue={setFieldValue}
              field={field}
              isConstructorForm={isConstructorForm}
              values={values}
              projectId={projectId}
            />
          )
        )}
        {((field.type === reference.id && field.refCollection.displayType === 'dropdown') ||
          field.type === belongsTo.id) && (
          <Reference
            field={field}
            setFieldValue={setFieldValue}
            values={values}
            projectId={projectId}
            isConstructorForm={isConstructorForm}
            version={version}
          />
        )}
        {field.type === reference.id && field.refCollection.displayType === 'innerForm' && (
          <ReferenceFieldForm
            field={field}
            setFieldValue={setFieldValue}
            collections={collections}
            values={values}
            projectId={projectId}
            version={version}
            setSubmitting={setSubmitting}
            collectionId={collectionId}
            isConstructorForm={isConstructorForm}
            setErrors={setErrors}
            plugins={plugins}
            s3Url={s3Url}
          />
        )}
        {field.type === dynamic_option.id && (
          <DynamicOptions
            field={field}
            setFieldValue={setFieldValue}
            values={values}
            projectId={projectId}
            isConstructorForm={isConstructorForm}
            version={version}
          />
        )}
        {field.type === boolean.id && (
          <BooleanField field={field} isConstructorForm={isConstructorForm} values={values} />
        )}
        {[number.id, unix_timestamp.id].includes(field.type) && (
          <NumberField field={field} isConstructorForm={isConstructorForm} />
        )}
        {field.type === color.id && (
          <ColorCodeField
            field={field}
            isConstructorForm={isConstructorForm}
            setFieldValue={setFieldValue}
            values={values}
          />
        )}
        {[date.id, ...timeSlotPicker].includes(field.type) && (
          <DateTimeField
            field={field}
            values={values}
            setFieldValue={setFieldValue}
            isConstructorForm={isConstructorForm}
            projectDetail={projectDetail}
          />
        )}
        {field.type === file.id && (
          <FileUploadField
            field={field}
            setFieldValue={setFieldValue}
            collectionId={collectionId}
            projectId={projectId}
            version={version}
            values={values}
            isConstructorForm={isConstructorForm}
            setSubmitting={setSubmitting}
            setErrors={setErrors}
            setFieldTouched={this.props.setFieldTouched}
            plugins={plugins}
          />
        )}
        {field.type === image.id && (
          <ImageUploadField
            field={field}
            setFieldValue={setFieldValue}
            collectionId={collectionId}
            values={values}
            projectId={projectId}
            isConstructorForm={isConstructorForm}
            setSubmitting={setSubmitting}
            plugins={plugins}
          />
        )}
        {field.type === multi_image.id && (
          <MultiImageUploadField
            field={field}
            setFieldValue={setFieldValue}
            collectionId={collectionId}
            values={values}
            projectId={projectId}
            version={version}
            plugins={plugins}
            isConstructorForm={isConstructorForm}
          />
        )}
        {field.type === static_option.id && (
          <StaticOptions
            field={field}
            setFieldValue={setFieldValue}
            values={values}
            projectId={projectId}
            isConstructorForm={isConstructorForm}
          />
        )}
        {field.type === tel.id && (
          <PhoneNumberField
            field={field}
            values={values}
            setFieldValue={setFieldValue}
            isConstructorForm={isConstructorForm}
            setErrors={setErrors}
          />
        )}
        {field.type === email.id && (
          <EmailField field={field} isConstructorForm={isConstructorForm} />
        )}
        {field.type === slug.id && (
          <SlugField field={field} isConstructorForm={isConstructorForm} />
        )}
        {field.type === json.id && (
          <JSONField field={field} isConstructorForm={isConstructorForm} />
        )}
        {field.type === markdown.id && (
          <MarkdownField field={field} isConstructorForm={isConstructorForm} />
        )}
      </Fragment>
    );
  }
}

export default CreateFormForItem;
